import Dashboard from "@/modules/common/pages/dashboard/Dashboard";

export default [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            caption: '首页',
        }
    }
];



// WEBPACK FOOTER //
// ./src/modules/common/router.js